<template>
  <div>
    <slot name="header">
      <LayoutHeader :type="type" />
    </slot>
    <main
      class="flex flex-col min-h-md"
      :class="{
        mobile: isMobile,
      }">
      <slot />
    </main>
    <slot name="footer">
      <LazyFooterJav v-if="isAlt" />
      <LazyFooter v-else />
    </slot>
  </div>
</template>

<script lang="ts" setup>
import { useStoreConfig } from '~/store/storeConfig'
import LayoutEnum from '~/enums/LayoutEnum'

const { isMobile } = useStoreConfig()
const { isAlt } = useTheme()
const type = ref(LayoutEnum.Quote)
</script>

<style lang="postcss" scoped>
main {
  &.mobile {
    margin-top: theme('vars.mobileHeaderHeight');
  }
}
</style>
